import { render, staticRenderFns } from "./BillInboxPdfViewer.vue?vue&type=template&id=9ccb35f8&scoped=true&"
import script from "./BillInboxPdfViewer.vue?vue&type=script&lang=js&"
export * from "./BillInboxPdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./BillInboxPdfViewer.vue?vue&type=style&index=0&id=9ccb35f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccb35f8",
  null
  
)

export default component.exports